<div
	class="p-6 rounded-2xl border duration-300 hover:shadow cursor-pointer"
	[ngClass]="{
		'border-amber-200 bg-amber-50': note.pinned,
		'border-gray-200': !note.pinned,
	}"
	(click)="updateNote(note.id)"
	[testHook]="testHooks.UpdateNoteDiv"
>
	<div class="flex-1 flex flex-col gap-4">
		<div class="flex justify-between items-center gap-2">
			<div class="flex gap-2 items-center overflow-hidden">
				<p class="font-semibold truncate 2xl:w-auto">{{ note.title }}</p>
				<button
					class="flex items-center justify-center h-7 w-7 shrink-0 cursor-pointer border hover:text-amber-600 rounded-md duration-300"
					[ngClass]="{
						'border-amber-200 text-amber-600 bg-amber-50': note.pinned,
						'border-transparent hover:bg-gray-50': !note.pinned,
					}"
					(click)="updatePinned(!note.pinned); $event.stopPropagation()"
					[testHook]="testHooks.UpdatePinButton"
				>
					<i-tabler name="pin" class="w-4 h-4"></i-tabler>
				</button>
			</div>
			<ui-button
				icon="trash"
				size="sm"
				preset="ICON_DEFAULT"
				(click)="onDeleteNote(note.id); $event.stopPropagation()"
			></ui-button>
		</div>
		<p class="text-sm notes-description">{{ note.description }}</p>
		<div class="flex justify-between flex-col 2xl:flex-row gap-1">
			<div class="flex gap-2">
				<p class="text-xs font-semibold">Created:</p>
				<div class="flex gap-2">
					<p class="text-xs">
						{{ note.createdAt | date: 'longDate' }} &middot;
						{{ note.createdAt | date: 'shortTime' }}
					</p>
					<div class="border-l border-gray-200"></div>
					<p class="text-xs">
						{{ note.creatorFirstName }}
						{{ note.creatorLastName }}
					</p>
				</div>
			</div>
			<div class="flex gap-1" *ngIf="note.updatedAt">
				<p class="text-xs font-semibold">Updated:</p>
				<div class="flex gap-2">
					<p class="text-xs">
						{{ note.updatedAt | date: 'longDate' }} &middot;
						{{ note.updatedAt | date: 'shortTime' }}
					</p>
					<div class="border-l border-gray-200"></div>
					<p class="text-xs">
						{{ note.lastUpdatedByFirstName }}
						{{ note.lastUpdatedByLastName }}
					</p>
				</div>
			</div>
		</div>
	</div>
</div>
